module.exports = __webpack_public_path__ + "static/media/tra_veh_res_sys.61976c5d.png";